import { render, staticRenderFns } from "./DragAndDrop.vue?vue&type=template&id=270c652e&"
import script from "./DragAndDrop.vue?vue&type=script&lang=js&"
export * from "./DragAndDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports